<div class="app-container">
  <!-- Loading Screen -->
  <app-loading-screen *ngIf="(loading$ | async) && !isAdminRoute && !isMaintenanceRoute"></app-loading-screen>

  <!-- Main Content -->
  <div class="main-content" [class.admin-route]="isAdminRoute" [class.funnel-route]="isFunnelRoute" [class.maintenance-route]="isMaintenanceRoute">
    <app-navbar *ngIf="!isAdminRoute && !isMaintenanceRoute"></app-navbar>
    <router-outlet></router-outlet>
    <app-footer *ngIf="!isAdminRoute && !isMaintenanceRoute"></app-footer>
  </div>

  <!-- Visitor Chat -->
  <app-visitor-chat *ngIf="showVisitorChat"></app-visitor-chat>
</div>
